import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertType, AppState } from './types';

// const DEFAULT_MAINTENANCE_MESSAGE =
//   'This system is currently undergoing maintenance. You may experience errors in the meantime, we appreciate your patience.';

const initialState: AppState = {
  alert: {
    type: AlertType.WARNING,
    message: '',
  },
  isLoading: false,
  isMobile: window.innerWidth < 768,
  isFileExplorerOpen: window.innerWidth >= 768,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    // Mobile state actions
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
      // When switching to desktop, show file explorer
      if (!action.payload) {
        state.isFileExplorerOpen = true;
      } else {
        // When switching to mobile, hide admin
        state.isFileExplorerOpen = false;
      }
    },
    toggleFileExplorer: (state) => {
      state.isFileExplorerOpen = !state.isFileExplorerOpen;
    },
    closeFileExplorer: (state) => {
      if (state.isMobile) {
        state.isFileExplorerOpen = false;
      }
    },
    setGlobalAlert: (
      state,
      action: PayloadAction<{
        type: AlertType;
        message: string;
      }>,
    ) => {
      state.alert = {
        type: action.payload.type,
        message: action.payload.message,
      };
    },
    clearGlobalAlert: (state) => {
      state.alert = null;
    },
  },
});

export const {
  setLoading,
  setGlobalAlert,
  clearGlobalAlert,
  setIsMobile,
  toggleFileExplorer,
  closeFileExplorer,
} = appSlice.actions;

export default appSlice.reducer;
